module.exports = __webpack_public_path__ + "static/media/btn_save_imagesheet@2x.502e53c0.png";